import React, { FC } from "react";

import classNames from "classnames";
import styled from "@emotion/styled";

export interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id: string;
  dark?: string;
  label?: string;
  error?: string;
}

const Input: FC<InputProps> = ({
  id,
  dark,
  label,
  error,
  className,
  ...props
}) => {
  return (
    <InputWrapper>
      {label && (
        <label htmlFor={id} className={classNames("p2", { [dark]: dark })}>
          {label}
        </label>
      )}
      <InputOverride
        id={id}
        className={classNames(className, { [dark]: dark })}
        {...props}
      />
      {error && <InputError>{error}</InputError>}
    </InputWrapper>
  );
};

const InputWrapper = styled.div`
  width: 100%;
`;

const InputOverride = styled.input`
  margin-bottom: 0 !important;
`;

const InputError = styled.span`
  display: block;
  color: #e31c79;
  margin-top: 0.5rem;
  font-family: "Clan news", sans-serif;
`;

export default Input;
